import { Fragment, type ReactNode } from "react";

import { GauTerm } from "./GauTerm";

/**
 * Renders a plain string, replacing each whole-word "GAU" / "GAUs" with
 * {@link GauTerm} so every mention gets the dotted underline + definition
 * tooltip. Word-boundary anchored so substrings of larger words (e.g.
 * "GAUGE") are left untouched.
 */
export function GauInText({ children }: { children: string }): ReactNode {
  const parts = children.split(/\b(GAUs?)\b/g);
  return (
    <>
      {parts.map((part, index) => {
        if (part === "GAUs") {
          return <GauTerm key={index} plural />;
        }
        if (part === "GAU") {
          return <GauTerm key={index} />;
        }
        if (!part) {
          return null;
        }
        return <Fragment key={index}>{part}</Fragment>;
      })}
    </>
  );
}
